import { render } from "./DashboardHeader.vue?vue&type=template&id=2dd12375&scoped=true"
const script = {}

import "./DashboardHeader.vue?vue&type=style&index=0&id=2dd12375&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dd12375"]])

export default __exports__